/**
 * Whether a keydown is the platform's "find in page" chord — Ctrl+F on
 * Windows/Linux, ⌘F on macOS (#755). Alt/Option is excluded so a text
 * shortcut like Alt+F never opens the search.
 */
export function isFindShortcut(e: {
  key: string
  ctrlKey: boolean
  metaKey: boolean
  altKey: boolean
}): boolean {
  if (e.altKey) return false
  if (!(e.ctrlKey || e.metaKey)) return false
  return e.key === 'f' || e.key === 'F'
}

/**
 * Whether a preview element sits in the window the user is working in. Windows
 * carry `data-active`; an element outside any window (standalone chat route,
 * shared-file page) counts as active because nothing competes with it.
 */
export function isInActiveWindow(el: Element): boolean {
  const windowEl = el.closest('[data-active]')
  return !windowEl || windowEl.getAttribute('data-active') === 'true'
}
